import React from 'react';
import { Box } from '@material-ui/core';

class TopFooter extends React.Component {
  render() {
    return (
      <div>
        <Box className="stepfooter">
          <p>
            このワークプレイス・シュミレーターは数多くのオフィス・データを入力した弊社のワークプレイスBIMエンジンcodettaを活用し算出しています。
          </p>
          <p>Copyright(C) WorkPath Inc. All Rights Reserved.</p>
        </Box>
      </div>
    );
  }
}

export default TopFooter;
